import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VRow,[_c(VCol,[_vm._v(" Grupos de Solução desabilitados ")])],1),_c(VRow,[_c(VCol,[_c(VDataTable,{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.solutionsGroup,"item-key":"name"},scopedSlots:_vm._u([{key:"item.acoes",fn:function({ item }){return [_c('AppModalRecoverGroup',{attrs:{"payload":{
              nomeGrupo: item.nome,
              municipioid: item.municipioId,
              municipiogruposolucaoid: item.municipioGrupoSolucaoId,
            }},on:{"onRecover":_vm.onRecoverM}})]}}])},[_c('template',{slot:"no-data"},[_c('div',[_vm._v("Não há Grupos de Solução desabilitados")])])],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }